import pic from "assets/svg/whatsapp.svg";
import "./mail.css";

const Whatsapp = () => {
  // const navigate = useNavigate();
  return (
    <>
      <p className="mail-txt">Hi, How can we help you?</p>
      <a
        className="mail-btn md-shadow hover:scale-110"
        href="https://wa.me/+2349071364105"
        rel="noreferrer"
        target="_blank"
      >
        <img src={pic} alt="" />
      </a>
    </>
  );
};

export default Whatsapp;
